export class WebhookV1StandardPayloadViolations {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "WebhookV1StandardPayloadViolationsTypeEnum",
            "format": ""
        },
        {
            "name": "arguments",
            "baseName": "arguments",
            "type": "WebhookV1StandardPayloadViolationsArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadViolations.attributeTypeMap;
    }
    constructor() {
    }
}
export var WebhookV1StandardPayloadViolationsTypeEnum;
(function (WebhookV1StandardPayloadViolationsTypeEnum) {
    WebhookV1StandardPayloadViolationsTypeEnum["HighSeverityViolationsDetectedOnResources"] = "HIGH_SEVERITY_VIOLATIONS_DETECTED_ON_RESOURCES";
    WebhookV1StandardPayloadViolationsTypeEnum["MediumSeverityViolationsDetectedOnResources"] = "MEDIUM_SEVERITY_VIOLATIONS_DETECTED_ON_RESOURCES";
    WebhookV1StandardPayloadViolationsTypeEnum["LowSeverityViolationsDetectedOnResources"] = "LOW_SEVERITY_VIOLATIONS_DETECTED_ON_RESOURCES";
    WebhookV1StandardPayloadViolationsTypeEnum["ViolationsResolvedOnResources"] = "VIOLATIONS_RESOLVED_ON_RESOURCES";
})(WebhookV1StandardPayloadViolationsTypeEnum || (WebhookV1StandardPayloadViolationsTypeEnum = {}));
